<div class="container">
  <div class="left-most">
    <img src="assets/logos/logo_with_text.png" />
    <p class="subtext">The ultimate tool for minimap rendering in Roblox </p>
    <p-button label="Join Our Discord" icon="pi pi-discord" severity="info" (click)="openDiscord()"/>
  </div>
  <div class="middle">
    <p-button label="Features" text severity="secondary" (click)="navigateAndScrollTo('features')"></p-button>
    <p-button label="Reviews" text severity="secondary" (click)="navigateAndScrollTo('reviews')"></p-button>
    <p-button label="Pricing" text severity="secondary" (click)="navigateAndScrollTo('pricing')"></p-button>
    <p-button label="FAQ" text severity="secondary" (click)="navigateAndScrollTo('faq')"></p-button>
  </div>
  <div class="right-most">
    <p-button label="Terms & Conditions" text severity="secondary" (click)="goTos()"/>
    <p-button label="Privacy Policy" routerLink="privacy" text severity="secondary" (click)="goPrivacy()" />
    <p-button label="Support Email" text severity="secondary" (click)="goSupportEmail()"/>
    <p-button label="Documentation" text severity="secondary" (click)="goDocs()"/>
  </div>
</div>
